import { extendObservable } from 'mobx'

export default class Comment {
  constructor (commentData) {
    extendObservable(this, {
      loading: false,
      error: null,

      // id: null,
      // expertId: null,
      // expertProjectLinkId: null,
      // averageRating: null,
      // rating1: null,
      // comment1: null,
      // rating2: null,
      // comment2: null,
      // rating3: null,
      // comment3: null,
      // rating4: null,
      // comment4: null,
      // dateSent: null,
      // dateSubmitted: null,

      ...commentData
    })
  }
}
